(function($) {
	'use strict';
	$.fn.Collection__Sort_DragAndDrop = function() {
		this.each(function() {

			/* jshint loopfunc: true, curly: false, freeze: false */
			var $self = $(this),
				collection_id = $self.data('cid'),
				$slides = $self.children('[draggable]'),
				orientation = $self.hasClass('collection-grid') ? 'x' : 'y',
				$current;

			$slides.on( 'dragstart', function() {

				// Save $current for dragover
				$current = $(this);

				// Add ghost class
				$current.addClass('ghost');

			}).on( 'dragover', function(e) {
			    e.preventDefault();

				// If we are not over ourself
				if( $(this).data('sid') !== $current.data('sid') ) {

					// Determine when mouse crosses halfway across element
					var $this = $(this),
						slide_id = $this.data('sid');

					// X or Y based (grid or list)
					if( orientation === 'x' ) {

						var x = e.clientX - $this.offset().left,
							half_width = $this.width() / 2;
						if( x > half_width && $this.next().data('sid') !== slide_id ) {
							$this.after( $current );
						} else if( x < half_width  && $this.prev().data('sid') !== slide_id ) {
							$this.before( $current );
						}

					} else if( orientation === 'y' ){

						var y = e.clientY - $this.offset().top,
							half_height = $this.height() / 2;
						if( y > half_height && $this.next().data('sid') !== slide_id ) {
							$this.after( $current );
						} else if( y < half_height  && $this.prev().data('sid') !== slide_id ) {
							$this.before( $current );
						}

					}

				}

			}).on( 'dragend', function(e) {
				e.preventDefault();
				$current.removeClass('ghost');

				var sids = '';
				$self.children().each( function() {

					var sid = $(this).data('sid');
					if( sid === undefined ) return;

					if( sids.length > 0 ) sids += ',';
					sids += sid;
				});

				// Update order
				$.Globals.ajax( 'scspaces_sort_collection', { cid: collection_id, sids: sids} );
			});

		});
		return this;
	};
}(jQuery));
